// extracted by mini-css-extract-plugin
module.exports = {"patients":"Patients_patients__37SYl","infiniteScroll":"Patients_infiniteScroll__2ZR4_"};